import { LayoutProps } from 'components/types';
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedStateCode, setSelectedStateCode } from 'state/ducks/customer-preference/slice';
import { selectStringTranslator } from 'state/ducks/translator-strings/slice';
import { AvailableStates, AvailableStatesMap } from 'state/static-data';
import { CSA, TranslatorStringIds } from 'utils';
import StateWaitlistWidget from './JoinWaitlist';
import InitialContext from 'state/static-data/InitialContext';
import { BUY_BOX_PAGE_TYPE } from 'state/types';


const StatesWidget = ({ layoutMode }: LayoutProps) => {
    const dispatch = useDispatch();
    const t = useSelector(selectStringTranslator);
    const dropdownRef = useRef();
    const states = AvailableStates
    const selectedStateCode = useSelector(selectSelectedStateCode);
    const selectedState = !!selectedStateCode && AvailableStatesMap[selectedStateCode];
    const showCheckAvailabilityButtonFlag = !selectedState;
    const buyboxStateHeaderText = InitialContext.getPageType() === BUY_BOX_PAGE_TYPE.DETAIL_PAGE
        ? TranslatorStringIds.ChooseYourStateHead
        : TranslatorStringIds.ChooseAStateHead
    const buyboxStateDescriptionText = InitialContext.getPageType() === BUY_BOX_PAGE_TYPE.DETAIL_PAGE
        ? TranslatorStringIds.ChooseYourStateDescription
        : TranslatorStringIds.ChooseAStateDescription;

    useEffect(() => {
        const loadDropdown = async () => {
            await window.customElements.whenDefined('pui-dropdown-two');
            const dropdown: any = dropdownRef.current;
            if (dropdown) {
                dropdown.onSelect = (value: string) => {
                    CSA.buyingOptionReloaded()
                    dispatch(setSelectedStateCode(value));
                };
            }
        };
        loadDropdown();
    }, []);

    return (
        <pui-section spacingTop="small">
            <pui-heading input={t.resolve(buyboxStateHeaderText)}
                spacingBottom="small"></pui-heading>
            <div className="pui-text medium-font normal-font-weight wrap-overflow">
                <pui-text spacingBottom="small" input={t.resolve(buyboxStateDescriptionText)}></pui-text>
            </div>
            <pui-dropdown-two
                name="location"
                label={t.resolve(TranslatorStringIds.ChooseYourStateSelectorLabel)}
                placeholder={t.resolve(TranslatorStringIds.ChooseYourStateSelectorPlaceholder)}
                selectedText={selectedState ? selectedState.label : undefined}
                enableScrollbar="true"
                ref={dropdownRef}>
                {states.map(state => {
                    return <pui-dropdown-item-two key={state.stateCode} value={state.stateCode}
                        type="option"
                        label={state.label} />
                })}
            </pui-dropdown-two>
            {showCheckAvailabilityButtonFlag &&
                <pui-button
                    label={t.resolve(TranslatorStringIds.ChooseYourStateCheckAvailabilityButton)}
                    textSize="large"
                ></pui-button>}
            {selectedState && <StateWaitlistWidget selectedState={selectedState} layoutMode={layoutMode} />}
        </pui-section>
    )
}
export default StatesWidget;